export const interventionObjectivePathName = 'intervention-objective';
